import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: { padding: '4px 0' },
  instructions: { padding: '2px 0', wordWrap: 'break-word' },
  instructionsValue: { fontWeight: 600, paddingLeft: '2px' }
});

const RenderSpecialInstructions = ({ shipment, classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.instructions}>
        PRO#<span className={classes.instructionsValue}>{shipment.proId}</span>
      </div>
      {shipment.specialInstructions ? (
        <div className={classes.instructions}>
          Special Instruction:
          <span className={classes.instructionsValue}>{shipment.specialInstructions}</span>
        </div>
      ) : null}
      {shipment.drComments?.length ? (
        <div className={classes.instructions}>
          DR Comment:
          <span className={classes.instructionsValue}>{shipment.drComments.join(", ")}</span>
        </div>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(RenderSpecialInstructions);
